import React from 'react';
import './Unit.css';

const Unit = ({ unit, onGetSkillInfo, availableSkills, sortKey }) => {

	let unitClass = 'unit bg-white pa2 near-black ph3-ns tl ' + unit.part + ' ' + unit.attribute + ' star-' + unit.rarity;
	unitClass += unit.part_type != null ? ' ' + unit.part_type : '';
	unitClass += unit.rank != null ? ' ' + unit.rank : '';

	const skillInfo = availableSkills.filter((skill) => {

		return skill.skill_id === unit.skillid;
	});

	let unitSkillClass = 'unit-skill flex flex-wrap pointer pr1';
	if ( availableSkills.filter( (skill) => { return skill.skill_id === unit.skillid } ).length > 0) {

		unitSkillClass = unitSkillClass + ' loaded rendered';
	} else {

		unitSkillClass = unitSkillClass + ' hidden';
	}

	return (
		<article className={unitClass.toLowerCase()}>
			<div className='unit-details-1'>
				<div className='fl mr2'>
					<div className='unit-icon'>
						<i className='unit-attr'></i>
						<i className='unit-rank'>{ unit.rank ? unit.rank : '-' }</i>
					</div>
				</div>
				<div>
					<h1 className='unit-name'>
						{unit.name}
						<span className='db f7 fw3 i'>{unit.subname ? unit.subname : ''}</span>
					</h1>
					<div className='db fw3 lh-copy part-type tl'>
						<div>
							{ unit.part_type ? (unit.part !== 'Pilot' ? 'Type: ' : '') + unit.part_type : '' }
							{ unit.damage_type ? ' ( ' + unit.damage_type + ' )' : '' }
						</div>
						<div>{ unit.integration ? 'Integration: ' + unit.integration : '' }</div>
					</div>
				</div>
			</div>
			<div className='unit-details-2'>
				<div className='bt f6 b--light-gray relative w-100 overflow-hidden'>
					<div className='unit-stats-container flex flex-wrap pv1 pv2-ns flex-nowrap-ns justify-around-ns'>
						<div className={sortKey === 'armor' ? 'unit-stats highlight w-100 w-auto-ns' : 'unit-stats w-100 w-auto-ns'}>
							<span className='normal'>Armor:</span> <span>{unit.armor}</span>
						</div>
						<div className={sortKey === 'atk_melee' ? 'unit-stats highlight' : 'unit-stats'}>
							<span className='normal'>Melee ATK:</span> <span>{unit.atk_melee}</span>
						</div>
						<div className={sortKey === 'atk_shot' ? 'unit-stats highlight' : 'unit-stats'}>
							<span className='normal'>Shot ATK:</span> <span>{unit.atk_shot}</span>
						</div>
						<div className={sortKey === 'res_phys' ? 'unit-stats highlight' : 'unit-stats'}>
							<span className='normal'>Phys Res:</span> <span>{unit.res_phys}</span>
						</div>
						<div className={sortKey === 'def_melee' ? 'unit-stats highlight' : 'unit-stats'}>
							<span className='normal'>Melee DEF:</span> <span>{unit.def_melee}</span>
						</div>
						<div className={sortKey === 'def_shot' ? 'unit-stats highlight' : 'unit-stats'}>
							<span className='normal'>Shot DEF:</span> <span>{unit.def_shot}</span>
						</div>
						<div className={sortKey === 'res_beam' ? 'unit-stats highlight' : 'unit-stats'}>
							<span className='normal'>Beam Res:</span> <span>{unit.res_beam}</span>
						</div>
					</div>
				</div>
				<div className='skill-trait-container'>
					<div className='f7 f5-ns relative w-100 overflow-hidden mt1 mt0-ns skill-trait mr1-ns'>
						{ unit.skill ?
							<div onClick={onGetSkillInfo} data-skid={unit.skillid}>
								<div className={unitSkillClass}>
									<div className='flex w-90'>
										<span className='mr1 normal nowrap'>EX Skill:</span>
										<span className='b ttu'>{unit.skill}</span>
									</div>
									<div className="skill-info w-100">
										{ availableSkills.filter( (skill) => { return skill.skill_id === unit.skillid } ).length > 0 ?
											<div className='pt2 ph1'>
												<div><label>Type: <span className='normal'>{skillInfo[0].skill_type}</span></label></div>
												<div className='flex'>
													{ skillInfo[0].skill_pierce ?
														<label className='w-30 pt1'>Pierce: <span className='normal'>{skillInfo[0].skill_pierce}</span></label> : ''
													}
													{ skillInfo[0].skill_power ?
														<label className='w-30 pt1'>Power: <span className='normal'>{skillInfo[0].skill_power}</span></label> : ''
													}
													{ skillInfo[0].skill_magazine ?
													<label className='w-30 pt1'>Magazine: <span className='normal'>{skillInfo[0].skill_magazine}</span></label> : ''
													}
													{ skillInfo[0].skill_effect_time ?
													<label className='w-100 pt1'>Effect Time: <span className='normal'>{skillInfo[0].skill_effect_time}</span></label> : ''
													}
													{ skillInfo[0].skill_recovery ?
													<label className='w-100 pt1'>Recovery: <span className='normal'>{skillInfo[0].skill_recovery}</span></label> : ''
													}
												</div>
												<div className='flex flex-column'>
													<label className='lh-copy'>Cooldown: <span className='normal'>{skillInfo[0].skill_cooldown}</span></label>
													<label className='lh-copy'>Description: <span className='normal'>{skillInfo[0].skill_description}</span></label>
												</div>
											</div>
											: 
											<div className='normal pv2'>Getting EX Skill information...</div>
										}
									</div>
								</div>
							</div>
						:
							<div className='unit-trait flex'>
								<span className='mr1'>Trait:</span>
								<span className='normal'>{unit.trait}</span>
							</div>
						}
					</div>
					<div className='f7 f5-ns relative w-100 overflow-hidden mt1 mt0-ns skill-trait ml1-ns'>
						<div className='unit-wordtags'>
							<span className='unit-wordtags-title normal'>Wordtags:</span>
							<div className='unit-wordtags-container'>
								<div className='di ttu unit-wordtag'>{unit.wordtag1}, </div>
								<div className='di ttu unit-wordtag'>{unit.wordtag2}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</article>
		)
};

export default Unit;